import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {User} from '../../data-access-layer/interfaces/users.interface';
import {UserService} from '../../data-access-layer/services/users.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangeGroup, ChangeItem, DialogData, StatusDialogComponent } from './status_dialog.component';
import { AuthService } from '../../data-access-layer/services/auth.service';
import { UserSessionStorageService } from '../../data-access-layer/services/user-sessions.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { HubConnection } from '@microsoft/signalr';
import { SignalRService } from '../../data-access-layer/services/signalr';
import { PythonService } from '../../data-access-layer/services/python.service';
import { SourceService } from '../../data-access-layer/services/sources.service';

@Component({
  selector: 'app-login',
  templateUrl: '../templates/login.component.html',
  styleUrl: '../templates/styles/login.component.css',
  standalone: false
})
export class LoginComponent implements OnInit {
  public users: User[] = [];
  public currentUser: User = { userId: 0, userName: '', userPassword: '', userRole: 'Пользователь', isAD: false };
  public isLogged: boolean = false;
  username: string = '';
  password: string = '';
  isUserAD: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private signalRService: SignalRService,
    private authservice: AuthService,
    private sessionService: UserSessionStorageService,
    private pythonService: PythonService,
    private sourceService: SourceService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.isLogged = this.sessionService.getItem('currentUser') !== null;

    if (this.isLogged)
      this.router.navigate(['/content']);
  }

  login() {
    const request = this.isUserAD
      ? this.userService.getUserAD({userName: this.currentUser.userName})
      : this.userService.getUser(this.currentUser);
    request.subscribe({
      next: (response) => {
        this.currentUser = response;

        let request = {
          Id: this.currentUser.userId,
          Role: this.currentUser.userRole
        }
        this.authservice.getToken(request).subscribe(async (response) => {
          this.sessionService.setItem("access_token", response);
          this.sessionService.setItem('currentUser', JSON.stringify(this.currentUser));

          this.authservice.setCurrentUser(this.currentUser);
          await this.establishSignalRConnection(response);

          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);

          forkJoin({
            summaryDWH: this.pythonService.getLogSummary({
              start_dt: yesterday.toISOString().slice(0, 10),
              end_dt: new Date().toISOString().slice(0, 10),
              datasource_type: 'dwh'
            }),
            summaryBI: this.pythonService.getLogSummary({
              start_dt: yesterday.toISOString().slice(0, 10),
              end_dt: new Date().toISOString().slice(0, 10),
              datasource_type: 'report'
            }),
            dwh: this.sourceService.getDWHSources(),
            bi: this.sourceService.getBISources()
          }).subscribe(({ summaryDWH, summaryBI, dwh, bi }) => {
            const sourceDWHMap = new Map(dwh.map(s => [s.id, s.dataSourceName]));
            const sourceBIMap = new Map(bi.map(s => [s.id, s.dataSourceName]));

            const groups: ChangeGroup[] = [];

            const pushDWH = (id: number, name: string, stats: any) => {
              const items: ChangeItem[] = [];
              const sum = (o: any) => (o.table || 0) + (o.view || 0) + (o.procedure || 0) + (o.function || 0);
              const created = sum(stats.new);
              const updated = sum(stats.updated);
              const deleted = sum(stats.deleted);
              if (created > 0) items.push({ kind: 'created', total: created, breakdown: stats.new, label: 'объектов' });
              if (updated > 0) items.push({ kind: 'updated', total: updated, breakdown: stats.updated, label: 'объектов' });
              if (deleted > 0) items.push({ kind: 'deleted', total: deleted, breakdown: stats.deleted, label: 'объектов' });
              if (items.length) groups.push({ id: id, name, type: 'dwh', items });
            };

            const pushBI = (id: number, name: string, stats: any) => {
              const items: ChangeItem[] = [];
              if ((stats.new?.report || 0) > 0) items.push({ kind: 'created', total: stats.new.report, label: 'отчетов' });
              if ((stats.updated?.report || 0) > 0) items.push({ kind: 'updated', total: stats.updated.report, label: 'отчетов' });
              if ((stats.deleted?.report || 0) > 0) items.push({ kind: 'deleted', total: stats.deleted.report, label: 'отчетов' });
              if (items.length) groups.push({ id: id, name, type: 'report', items });
            };

            summaryDWH.datasources.forEach(ds => {
              const sourceName = sourceDWHMap.get(ds.datasource_id) || `Источник #${ds.datasource_id}`;
              pushDWH(ds.datasource_id, sourceName, ds.statistics);
            });
            summaryBI.datasources.forEach(ds => {
              const sourceName = sourceBIMap.get(ds.datasource_id) || `Источник #${ds.datasource_id}`;
              pushBI(ds.datasource_id, sourceName, ds.statistics);
            });

            if (groups.length === 0) {
              this.dialog.open(StatusDialogComponent, {
                width: '420px',
                position: { top: '20px', right: '20px' },
                data: {
                  title: 'Обновления источников данных',
                  type: 'info'
                } as DialogData
              });
              this.router.navigate(['/content']);
              return;
            }

            this.dialog.open(StatusDialogComponent, {
              width: '420px',
              position: { top: '20px', right: '20px' },
              data: {
                title: 'Обновления источников данных',
                rows: groups,
                type: 'info'
              } as DialogData
            });


            this.router.navigate(['/content']);
          });

        });

        this.router.navigate(['/content']);
      }
    });
  }

  private async establishSignalRConnection(token: string) {
    await this.signalRService.connect(token);
  }

  logOut(): void {
    if (this.currentUser) {
      this.authservice.logOut();
    }
  }

}
